import React, { useState } from "react";
import axios from "axios";
import { JdsButton } from "../../../components/jds/JdsButton";
import { JdsTag } from "../../../components/jds/JdsTag";
import { ClienteModal } from "./clienteUi";
import Countdown from "./Countdown";
import { toast } from "react-toastify";
import { generateTraceId } from "../../../helpers";

export default function PixModal({
  setOpen,
  pixCode,
  pixQR,
  pixTimer,
  clientId,
  hideStatusCheck = false
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [paymentLoading, setPaymentLoading] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState(null);

  const handlePaymentCheck = async () => {
    if (!clientId) {
      toast.error("ID do cliente não encontrado.");
      return;
    }
    setPaymentLoading(true);
    try {
      // Simulate an API call to check payment status
      const response = await axios.get(
        process.env.REACT_APP_JUSBILL_URL +
          `/charges/pix/transaction/${encodeURIComponent(clientId)}`,
        {
          headers: {
            "x-trace-id": generateTraceId()
          }
        }
      );
      const status = response.data?.status;
      if (status === "paid") {
        setPaymentStatus("paid");
        toast.success("Pagamento confirmado!");
      } else if (status === "waiting_payment" || status === "pending") {
        toast.info("Pagamento em processamento.");
      } else {
        toast.error("Pagamento não encontrado. Tente novamente.");
      }
    } catch (error) {
      console.error("Erro ao verificar pagamento:", error);
      toast.error("Erro ao verificar pagamento. Tente novamente.");
    } finally {
      setPaymentLoading(false);
    }
  };

  return (
    <ClienteModal
      wide
      center={false}
      title="Pagar com Pix"
      description="Para completar o pagamento via Pix, envie o código para o cliente, assim ele poderá realizar o pagamento e continuar usando a plataforma."
      onClose={() => setOpen(false)}
    >
      <div className="d-flex flex-column" style={{ gap: "var(--space-8)" }}>
        <label htmlFor="pixCode">Copia e cola</label>
        {isLoading ? (
          <span
            className="spinner-border spinner-border-sm align-self-center"
            role="status"
            aria-hidden="true"
          ></span>
        ) : (
          <textarea
            id="pixCode"
            className="form-control cd-textarea-readonly"
            value={isLoading ? "" : pixCode}
            rows={1}
            onFocus={e => e.target.select()}
            readOnly
          />
        )}
        <div
          className="jds-surface d-flex flex-column align-items-center text-center"
          style={{ marginTop: "var(--space-16)", gap: "var(--space-8)" }}
        >
          <h3 className="jds-title-xs">Pagar com Pix</h3>
          <p className="text-muted mb-0">
            Copie o código Pix acima e cole no app do seu banco. Seu pagamento
            será aprovado em alguns instantes.
          </p>
          {isLoading ? (
            <div
              className="d-flex justify-content-center align-items-center text-center"
              style={{ width: "160px", height: "160px" }}
            >
              <span
                className="spinner-border"
                role="status"
                aria-hidden="true"
              ></span>
            </div>
          ) : (
            <img
              src={pixQR}
              loading="eager"
              alt="Código Pix"
              // QR precisa de fundo claro para ser lido, inclusive no dark
              style={{ width: "160px", height: "160px", background: "#fff" }}
            />
          )}
          <JdsButton
            variant="outlined"
            onClick={() =>
              navigator.clipboard
                .writeText(pixCode)
                .then(() => toast.success("Código copiado com sucesso!"))
                .catch(() =>
                  toast.error(
                    "Não foi possível copiar o código. Copie manualmente."
                  )
                )
            }
            disabled={isLoading}
          >
            Copiar código
          </JdsButton>
        </div>
        <div
          className="d-flex justify-content-between align-items-center"
          style={{ marginTop: "var(--space-16)" }}
        >
          <p className="mb-0">Pix disponível por</p>
          <Countdown
            seconds={pixTimer}
            secondsStyle={{ fontWeight: "var(--fw-semibold)" }}
          />
        </div>
        {!hideStatusCheck && (
          <div className="d-flex justify-content-between align-items-center">
            <p className="mb-0">Status do pagamento</p>
            {paymentStatus === "paid" ? (
              <JdsTag dot color="success" label="Pagamento confirmado" />
            ) : (
              <JdsButton
                variant="outlined"
                onClick={() => handlePaymentCheck()}
                disabled={isLoading || paymentLoading}
              >
                {paymentLoading ? (
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                ) : (
                  "Verificar"
                )}
              </JdsButton>
            )}
          </div>
        )}
      </div>
    </ClienteModal>
  );
}
